import React from "react";
import Pagination from "./pagination";

export default function HeaderList({
  pages,
  onSortChange,
  initialSortValue = "empty",
  currentPage,
  onPrevClick,
  onNextClick,
  onChangedPage,
}) {
  const [sortValue, setSortValue] = React.useState(() => initialSortValue);

  function handleChange(event) {
    const { value } = event.target;
    setSortValue(value);
    const [key, sortVal] = value.split(" ");
    onSortChange({ name: key, value: sortVal });
  }

  return (
    <div className="flex justify-start md:flex-row gap-2 flex-col py-4">
      <div className="flex w-full md:w-7/12 lg:w-5/12 gap-4">
        <select
          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-gray-500 text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
          name="order"
          value={sortValue}
          id="order"
          onChange={handleChange}
        >
          <option disabled value="empty">
            Ordernar por...
          </option>
          <option value="price asc">Precio ascendente</option>
          <option value="price desc">Precio descendente</option>
          <option value="km asc">Kilometraje ascendente</option>
          <option value="km desc">Kilometraje descendente</option>
          <option value="year asc">Año ascendente</option>
          <option value="year desc">Año descendente</option>
        </select>
        <button className="bg-red-600 w-full px-4 text-white rounded-md py-2">
          Autos financiados
        </button>
      </div>
      <Pagination
        currentPage={currentPage}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        pages={pages}
        onChangedPage={onChangedPage}
        className="md:w-5/12 lg:w-4/12"
      />
    </div>
  );
}
